import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addproductConvert from "./components/addproductConvert";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "productConvertList",
  mixins: [loadMoreList, commonData],
  components: {
    addproductConvert: addproductConvert,
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      pagingReqFn: "appPaymentGoodsData",
      delIds: [],
      paramsData: {
        isMustAppid: 2
      }
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getcommonData(['appListAllData', 'appPaymentTypeAllData']);

              _this.getList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    getadd: function getadd() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = [{
                  "appid": "46756288",
                  "payment_type_id": 21,
                  "product": "1042",
                  "third_part_product": "7",
                  "price": "3000",
                  "discount": "1",
                  "third_part_price": "30000",
                  "isMustAppid": 1
                }, {
                  "appid": "46756288",
                  "payment_type_id": 21,
                  "product": "1044",
                  "third_part_product": "7",
                  "price": "19800",
                  "discount": "1",
                  "third_part_price": "198000",
                  "isMustAppid": 1
                }];
                i = 0;

              case 2:
                if (!(i < list.length)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return _this2.$api.appPaymentGoodsAdd(list[i]);

              case 5:
                i++;
                _context2.next = 2;
                break;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var _this3 = this;

      this.$api.appPaymentGoodsData(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page: 1,
        page_size: 10000
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: '应用名称',
            prop: 'name'
          }, {
            label: '支付类型名称',
            prop: 'type_name'
          }, {
            label: '研发商品',
            prop: 'product'
          }, {
            label: '支付渠道商品',
            prop: 'third_part_product'
          }, {
            label: '价格',
            prop: 'price'
          }, {
            label: '支付渠道商品价格',
            prop: 'third_part_price'
          }, {
            label: '折扣',
            prop: 'discount'
          }, {
            label: '货币代码',
            prop: 'currency'
          }, {
            label: '商品名称',
            prop: 'product_name'
          }];

          _this3.$export.excel({
            columns: columns,
            data: res.data.data,
            title: _this3.$route.meta.title
          });
        }
      });
    },
    del: function del(dateList) {
      var _this4 = this;

      console.log(dateList);
      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appPaymentGoodsDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this4.getList(_this4.paramsData.page);
      });
    }
  }
};